<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h2 class="fmtitle">LIST OF PLATES</h2>
<p class="list"><span href="#/xhtml/Plates01#fig1" title="Link target outside of Sample"><span class="lno">1.</span> The Rev. Dr Richard Price FRS.</span></p>
<p class="list"><span href="#/xhtml/Plates01#fig2" title="Link target outside of Sample"><span class="lno">2.</span> Charles Watson Wentworth, 2nd Marquis of Rockingham.</span></p>
<p class="list"><span href="#/xhtml/Plates01#fig3" title="Link target outside of Sample"><span class="lno">3.</span> The Rev Christopher Wyvill.</span></p>
<p class="list"><span href="#/xhtml/Plates01#fig4" title="Link target outside of Sample"><span class="lno">4.</span> John Cartwright.</span></p>
<p class="list"><span href="#/xhtml/Plates01#fig5" title="Link target outside of Sample"><span class="lno">5.</span> The Rev. Dr Joseph Priestley.</span></p>
<p class="list"><span href="#/xhtml/Plates01#fig6" title="Link target outside of Sample"><span class="lno">6.</span> Thomas Paine.</span></p>
<p class="list"><span href="#/xhtml/Plates01#fig7" title="Link target outside of Sample"><span class="lno">7.</span> Edmund Burke.</span></p>
<p class="list"><span href="#/xhtml/Plates01#fig8" title="Link target outside of Sample"><span class="lno">8.</span> William Pitt.</span></p>
<p class="list"><span href="#/xhtml/Plates01#fig9" title="Link target outside of Sample"><span class="lno">9.</span> Charles James Fox.</span></p>
<p class="list1"><span href="#/xhtml/Plates01#fig10" title="Link target outside of Sample"><span class="lno1">10.</span> William Wentworth-Fitzwilliam, 4th Earl Fitzwilliam.</span></p>
<p class="list1"><span href="#/xhtml/Plates01#fig11" title="Link target outside of Sample"><span class="lno1">11.</span> Henry Redhead Yorke.</span></p>
<p class="list1"><span href="#/xhtml/Plates01#fig12" title="Link target outside of Sample"><span class="lno1">12.</span> The Rev. Thomas Johnstone.</span></p>
<p class="list1"><span href="#/xhtml/Plates01#fig13" title="Link target outside of Sample"><span class="lno1">13.</span> Edward Marcus Despard.</span></p>
<p class="list1"><span href="#/xhtml/Plates01#fig14" title="Link target outside of Sample"><span class="lno1">14.</span> Thomas Walker.</span></p>
<p class="list1"><span href="#/xhtml/Plates01#fig15" title="Link target outside of Sample"><span class="lno1">15.</span> The Rev. William Robert Hay.</span></p>
<p class="list1"><span href="#/xhtml/Plates01#fig16" title="Link target outside of Sample"><span class="lno1">16.</span> Robert Athorpe.</span></p>
<a id="page_viii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Plates.vue?25c21549